const $ = window.jQuery || window.$;

$('#downloadButton').on('click', function () {
  $('#formModal').removeClass('hidden')
})

$('.js-modal-close').on('click', function () {
  $(this).closest('.js-modal').addClass('hidden')
})

$('#smartnoteSubmit').on('click', function (e) {
  e.preventDefault()

  var form = $('#smartnoteForm')
  var formElement = form.get(0)
  var submitButton = window.FormSubmitState?.disable(formElement, this)

  $('.js-errors').text('').addClass('hidden')

  axios.post(form.attr('action'), form.serialize())
    .then(function (response) {
      $('#formModal').addClass('hidden')
      $('#messageModal').removeClass('hidden')
    })
    .catch(function (error) {
      var errors = error.response?.data?.errors

      if (!errors) {
        window.FormSubmitState?.enable(formElement, submitButton)
        return
      }

      Object.entries(errors).forEach(entry => {
        const [key, value] = entry;
        $('.js-error-' + key).text(value).removeClass('hidden')
      });

      if (window.turnstile) {
        window.turnstile.reset()
      }

      window.FormSubmitState?.enable(formElement, submitButton)
    });
})

$('.js-modal-close').on('click', function () {
  window.location.reload()
})
